import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WindowHandleService {

  showTopBarBehavior: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {}
}
